'use strict';

import _ from 'lodash'
import workflowApi from '../../../../modules/workflow/api'
import {WorkflowTaskStore, Task} from '../../../../modules/workflow/task/WorkflowTaskStore'
import {responseCreated} from '../../ReviewsTabData'
import { ToastService } from '../../../../components/toasts/Toasts';
import { hasSmartResponse } from "../../../../modules/app/site/featureAccessControl";
import {recordEvent} from "../../../../modules/app/plugins/metricPlugin";
import {installSurvey} from "../../../../modules/app/plugins/iterateUserFeedbackPlugin";

angular.module('clientDashboardApp').directive('reviewResponses', function() {

  return {
    restrict: 'A',
    replace: true,
    template: require('./reviewResponses.html'),
    scope: {
      review: '=',
      index: '=',
      responseTemplates: '=',
      openManageResponseTemplatesModal: '='
    },
    controller: (
      $rootScope, $scope, reviewService, reviewGenService,
      configService, userService,
      reviewResponseConfiguration,
      confirmService, reviewResponseService, userManagerService
    ) => {

      // Resolves user IDs => display names
      $scope.usernames = {}
      let requiredUserIds = []
      $scope.review.responses.forEach(response => {
        response.authorUserId && requiredUserIds.push(response.authorUserId)
        requiredUserIds = requiredUserIds.concat(response.notes.map(note => note.userId))
      })
      requiredUserIds = _.uniq(requiredUserIds)
      if (requiredUserIds.length > 0) {
        userManagerService.getUsers(_.uniq(requiredUserIds)).then(userMap => {
          $scope.usernames = _.mapValues(userMap, user => (user.firstName + ' ' + user.lastName))
        })
      }
      const currentUser = userService.getCurrentUser()
      $scope.usernames[currentUser.id] = `${currentUser.firstName} ${currentUser.lastName}`

      $scope.hasPendingTasks = function() {
        return !!_.find($scope.review.tasks, (task) => task.content.status === 'PendingApproval')
      }

      $scope.canUseSmartResponse = () => {
        return hasSmartResponse() && ($scope.review.canRespond || $scope.reviewResponse.enableResponseForm || false);
      }

      $scope.onSmartResponseStartLoad = () => {
        // Handler to start Skeleton UI.
        $scope.reviewResponse.loadingSuggestedReviewResponses = true;

        // Simulating loading progress
        $scope.reviewResponse.LoadedSuggestionsCount = 1;
        for (let i = 1; i < 4; i++) {
          setTimeout(function() {
            $scope.reviewResponse.LoadedSuggestionsCount = i;
            $scope.$apply(); // Need to apply every time to refresh the UI
          }, 2000 + (500 * i)); // Might wanna increase the timeout here. Response from the server is taking longer than 3 sec.
        }
      };
      $scope.onSmartResponseEndLoad = () => {
        // Handler to end Skeleton UI.
        $scope.reviewResponse.loadingSuggestedReviewResponses = false;
      };
      $scope.onSmartResponseReady = (template, index, templateId) => {
        $scope.smartResponseTemplate = template; // Helps to track if smart response template is submitted.
        $scope.smartResponseTemplateIndex = index; // Smart response template choice / index out of 3 generated
        $scope.reviewResponse.responseDetail = template;
        installSurvey('60ad58c441c6490001a6ba48');
        $scope.reviewResponseUsage.responseGeneration = true;
        $scope.reviewResponseUsage.smartResponseTemplateId = templateId;
        $scope.reviewResponseUsage.templateSelected = $scope.smartResponseTemplateIndex;
      }

      $scope.smartResponseClicksCounter = (counter) => {
        $scope.smartResponseButtonTotalClickes = counter
      }

      reviewResponseConfiguration.fetchResponseConfiguration().then(x => {
        const providerConfig = reviewResponseConfiguration.forProvider($scope.review.contentProvider);

        function applyCanRespond() {
          $scope.review.canRespond = reviewResponseConfiguration.isResponseAllowed($scope.review)
          $scope.review.canCreateDraft = reviewResponseConfiguration.isDraftResponseAllowed($scope.review)
          $scope.reviewResponse.enableResponseForm = $scope.review.canRespond || $scope.review.canCreateDraft
          $scope.review.showResponses = ($scope.review.responses || []).length > 0 || $scope.review.canRespond || $scope.review.canCreateDraft
        }

        applyCanRespond();
        if (providerConfig.requiresRespondableListing) {
          $scope.$watch($rootScope.respondableListings, applyCanRespond, true);
        }

        $scope.isReviewBuilder = providerConfig.isReviewBuilder;
        $scope.reviewResponse.providerEnabled = !providerConfig.unsupported;
        $scope.demoFlag = providerConfig.imitateResponsesForDemo;

        if ($scope.review.contentProvider === "GOOGLE" && $scope.review.providerReviewId === undefined) {
          // This case occurs if we are unable to gather a google review from the api
          $scope.reviewResponse.disabledTemplate = "missing-google-credentials.html"
        } else if (providerConfig.requiresRespondableListing && $scope.review.contentProvider === "GOOGLE") {
          // We want more specific wording for handling google errors
          $scope.reviewResponse.disabledTemplate = "missing-google-credentials.html"
        } else if ($scope.review.contentProvider === "TRUSTPILOT" && $scope.reviewResponse.providerEnabled && !$scope.reviewResponse.enableResponseForm) {
          $scope.reviewResponse.disabledTemplate = "trustpilot-missing-credentials.html";
          $scope.reviewResponse.popoverEnabled = true;
        } else if (providerConfig.requiresRespondableListing && $scope.review.contentProvider !== "GOOGLE") {
          $scope.reviewResponse.disabledTemplate = "missing-credentials.html"
        } else if (providerConfig.unsupported) {
          $scope.reviewResponse.disabledTemplate = "unsupported-provider.html"
        } else { // else it must be an account configuration option
          $scope.reviewResponse.disabledTemplate = "requires-configuration.html"
        }

        if ($scope.demoFlag) {
          // for response demo accounts, don't show publish errors
          _.forEach($scope.review.responses, (response) => {
            if (response.publishingStatus === "ERROR" || response.publishingStatus === "UNHANDLED_ERROR")
              return response.publishingStatus = "PUBLISHED";
          })
        }

        if (providerConfig.shouldShowForm) {
          $scope.reviewResponse.showRespondingForm = true
        }
      });



      // edit model for response
      $scope.reviewResponse = {
        isPublic: false,
        enableResponseForm: false,
        showRespondingForm: false,
        providerEnabled: false,
        loadingSuggestedReviewResponses: false
      };

      /**
       * @reviewId <object id> Review id
       * @responseGeneration <boolean> True if response generation was used
       * @editedTemplate <boolean> True if smart response was used, and the output was edited
       * @templateLibraryUsed <boolean> True if a template was used, if used templateId will be populated
       * @templateId <object id> Template id, populated if templateLibraryUsed is true
       * @templateSelected <int> Index of the template selected
       */
      $scope.reviewResponseUsage = {
        reviewId: $scope.review.reviewId,
        responseGeneration: false,
        editedTemplate: false,
        templateLibraryUsed: false,
        templateId: "",
        smartResponseTemplateId:[],
        templateSelected: 1,
        buttonClicksCounter: 0
      }

      $scope.defaultUserPic = '/images/man-default.png';

      $scope.applyTemplate = function(template) {
        $scope.reviewResponseUsage.templateLibraryUsed = true
        $scope.reviewResponseUsage.templateId = template._id
        $scope.reviewResponse.responseDetail = template.body
      };

      $scope.saveResponse = function() {
        if ($scope.isReviewBuilder || ($scope.review.canCreateDraft && !$scope.review.canRespond)) {
          saveResponse()    // Skip the warning if this is just submitting a draft
        } else {
          confirmService.confirm(
            "Submit review response",
            `<p>Please proofread before submitting. Once posted, this response will be visible to all visitors on your review page.</p>
             <p>Responses should directly address feedback in the review. <br> For example, if customer service and wait times are mentioned as complaints, your response should address both of these areas.</p>
             <p>We also recommend including your business name in responses to positive reviews. However, if the review is negative, we suggest leaving your name out of your response. These can appear in search results, so following this best practice will improve the likelihood that consumers see positive comments about your brand.</p>
             <p>Reminder: responding to reviews improves your rankings, increases customer loyalty, and shows other prospects you care, so the quality of your response is important. Keep up the good work!</p>
            `,
            confirmService.WARNING,
            "reviewResponse"
          ).then(confirmPost => {
            if (confirmPost === true) {
              saveResponse()
            }
          })
        }
      };

      function saveResponse () {
        const review = $scope.review
        $scope.reviewResponse.savingResponse = true;

        if ($scope.reviewResponseUsage.responseGeneration === true && $scope.smartResponseTemplate !== $scope.reviewResponse.responseDetail) {
          // If smart response was used but the response was edited
          $scope.reviewResponseUsage.editedTemplate = true
        }
        recordEvent('reviewResponse', $scope.reviewResponseUsage )
        let promise = reviewService.submitReviewResponse(review.reviewId, $scope.reviewResponse.responseDetail, $scope.reviewResponse.isPublic)
        promise.then(apiResponse => {
          let response = apiResponse.reviewResponse
          if (response.publishingStatus === "PUBLISHED") {
            review.responses = apiResponse.updatedReview.responses
              .map(responseToOriginalFormat)
          } else {
            if ($scope.demoFlag) {
              // for response demo accounts, don't show publish errors
              if (response.publishingStatus === "ERROR" || response.publishingStatus === "UNHANDLED_ERROR") {
                response.publishingStatus = "PUBLISHED"
              }
            }
            review.responses.push(responseToOriginalFormat(response));
          }
          $scope.$emit(responseCreated, {})
          $scope.reviewResponse.savingResponse = false
          $scope.clearResponseForm()
        }, error => {
          $scope.reviewResponse.savingResponse = false
          ToastService.error("Failed", `Failed to respond to review. Message: '${error.error}'`)
        })
      }

      $scope.clearResponseForm = function() {
        $scope.reviewResponse.responseDetail = null;
      }

      $scope.openTemplateEditorIfEmpty = function() {
        let hasManagePermissions = _.contains(userService.getCurrentUser().permissions, "ManageReviewResponseTemplates")
        if ((!$scope.responseTemplates || $scope.responseTemplates.length) == 0 && hasManagePermissions) {
          $scope.openManageResponseTemplatesModal()
        }
      }
      $scope.removeResponse = function(response) {
        reviewService.removeResponse($scope.review._id, response._id.$oid)
        $scope.review.responses = _.filter($scope.review.responses, (r) => r._id.$oid != response._id.$oid)
      }

      $scope.updateResponse = function(response, submit) {
        reviewService.updateReviewResponse($scope.review.reviewId, response._id.$oid, response.detail, submit)
          .then(apiResponse => {
            let updatedReviewResponse = responseToOriginalFormat(apiResponse.reviewResponse)
            $scope.review.responses = $scope.review.responses.map(r => {
              return r._id.$oid === updatedReviewResponse._id.$oid ? updatedReviewResponse : r
            })
          }, error => {
            ToastService.error("Failed", `Failed to respond to review. Message: '${error.error}'`)
          })
      }

      $scope.addNote = function(response, form) {
        if (form.$valid) {
          response.isSavingNote = true
          reviewResponseService.addNote($scope.review, response, response.newNote)
            .then((newNote) => {
              response.newNote = ''
              response.isSavingNote = false
              response.notes = response.notes || []
              response.notes.push(newNote)
            },
            (error) => {
              ToastService.error(`Failed to add note`)
              response.isSavingNote = false
            })
        }
      }

      $scope.removeNote = function(response, note) {
        reviewResponseService.removeNote($scope.review, response, note)
      }

      $scope.editNote = function(response, note) {
        reviewResponseService.updateNote($scope.review, response, note)
      }

      let didReject = false
      $scope.canRejectResponse = (response) => {
        return !didReject && response.publishingStatus === 'AWAITING_APPROVAL'
      }
      $scope.rejectResponse = function(response) {
        workflowApi.loadTasksByEntityIds($scope.review.reviewId, 'Review')
          .then(({ tasks }) => {
            const currentTask = tasks.find((task) => task.content.status !== 'Complete')
              return confirmService.prompt({
                heading: 'Reject Response',
                templateUrl: 'popover-reject-response.html',
                theme: confirmService.QUESTION,
                actions: [
                  {label: 'Cancel', btnType: 'btn-outline-secondary', reject: true},
                  {label: 'Reject', btnType: 'btn-secondary', resolve: true}
                ]
              }).then(results => {
                return reviewResponseService.rejectResponse($scope.review, response, results.params.rejectionReason);
              }).then(() => didReject = true)

            })

      }

    }

  };
});

export function responseToOriginalFormat(v5Response) {
  return {
    ...v5Response,
    _id: { $oid: v5Response.id },
    detail: v5Response.responseDetail,
    username: v5Response.responseUsername,
    date: v5Response.responseDate
  }
}